import React from 'react';

let UserContext = React.createContext({user: {}});

export default UserContext;